import { useMemo, useState } from 'react';
import { Loader, TriangleAlert, UserX } from 'lucide-react';
import { api } from '../api';
import { BarraJornada, EjeHoras, TotalesJornada } from '../components/BarraJornada';
import { SelectorFecha } from '../components/SelectorFecha';
import { LIMITE_CONDUCCION_H } from '../config/jornada';
import { fmtHora } from '../util/format';
import { hoyAR } from '../util/format';
import { useCarga } from '../util/hooks';

export function JornadasPagina() {
  const [fecha, setFecha] = useState(hoyAR());
  const { datos, cargando, error, recargar } = useCarga(() => api.jornadas(fecha), [fecha]);
  const jornadas = useMemo(() => [...(datos?.jornadas ?? [])].sort((a, b) => b.horasConduccion - a.horasConduccion), [datos]);
  const vigente = datos && datos.fecha === fecha;

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <div className="eyebrow">OPERACIONES / CHOFERES</div>
          <h1>Jornada de choferes</h1>
        </div>
        <SelectorFecha fecha={fecha} onCambiar={setFecha} />
      </div>

      {error && (
        <div className="banner error" role="alert">
          <TriangleAlert aria-hidden />
          {error}
          <button type="button" className="btn-sm" onClick={recargar}>Reintentar</button>
        </div>
      )}

      <div className="card jornadas">
        <div className="jrow head">
          <span>CHOFER</span>
          <EjeHoras />
          <span style={{ textAlign: 'right' }}>CONDUCCIÓN</span>
        </div>
        {cargando && !vigente && (
          <div className="skeleton">
            <Loader className="spin" aria-hidden size={16} />
            Cargando jornadas…
          </div>
        )}
        {vigente &&
          jornadas.map((j) => (
            <div className="jrow" key={j.llaveOperador}>
              <div className="nombre">
                {j.nombre ?? j.llaveOperador}
                <small>
                  {fmtHora(j.inicio)} a {fmtHora(j.fin)}
                </small>
              </div>
              <BarraJornada jornada={j} conEje={false} />
              <TotalesJornada jornada={j} />
            </div>
          ))}
        {vigente && jornadas.length === 0 && (
          <div className="vacio">
            <UserX aria-hidden />
            No hay jornadas registradas para este día.
          </div>
        )}
        <div className="leyenda">
          <span><i className="cond" /> Conducción</span>
          <span><i className="det" /> Detenido</span>
          <span>
            <TriangleAlert aria-hidden size={12} style={{ color: 'var(--amber)' }} /> Se resalta cuando la conducción supera {LIMITE_CONDUCCION_H} h (límite provisorio, a confirmar)
          </span>
        </div>
      </div>
    </div>
  );
}
